import React from 'react';
export function PrivacyPolicy() {
  return <div className="w-full min-h-screen bg-navy-900" data-id="element-450">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-451">
        <div className="mb-12" data-id="element-452">
          <a href="/" className="inline-flex items-center space-x-1 mb-8 group" data-id="element-453">
            <span className="text-2xl font-display font-bold text-white" data-id="element-454">
              Tru
            </span>
            <span className="text-2xl font-display font-bold text-teal-500" data-id="element-455">
              ID
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-amber-500 group-hover:scale-125 transition-transform" data-id="element-456"></span>
          </a>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-457">
            Política de Privacidad y Protección de Datos
          </h1>
          <div className="h-1 w-20 bg-teal-500 rounded" data-id="element-458"></div>
        </div>

        <div className="prose prose-invert max-w-none space-y-10 text-gray-300 leading-relaxed" data-id="element-459">
          <section data-id="element-460">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-461">
              1. INTRODUCCIÓN
            </h2>
            <p data-id="element-462">
              En TruID valoramos y respetamos la privacidad de nuestros
              usuarios. Esta Política de Privacidad describe cómo recopilamos,
              utilizamos, almacenamos y protegemos los datos personales que
              usted nos proporciona al utilizar nuestros sitios web, APPs,
              terminales de autoatención u otros sistemas o canales de
              comunicación.
            </p>
          </section>

          <section data-id="element-463">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-464">
              2. RESPONSABLE DEL TRATAMIENTO
            </h2>
            <p data-id="element-465">
              <span className="text-white font-medium" data-id="element-466">
                Nombre de la entidad:
              </span>{' '}
              TruID es procesado por ZUMPAGOECUADOR SAS
            </p>
            <p className="mt-2" data-id="element-467">
              <span className="text-white font-medium" data-id="element-468">
                Correo electrónico de contacto:
              </span>{' '}
              <a href="mailto:protecciondatos@truid.org" className="text-teal-500 hover:text-teal-400 transition-colors" data-id="element-469">
                protecciondatos@truid.org
              </a>
            </p>
          </section>

          <section data-id="element-470">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-471">
              3. DATOS PERSONALES QUE RECOPILAMOS
            </h2>
            <p className="mb-4" data-id="element-472">
              Podemos recopilar los siguientes datos personales cuando navegas o
              interactúas con nuestro sitio web u otros canales:
            </p>
            <ul className="list-disc list-inside space-y-2" data-id="element-473">
              <li data-id="element-474">Nombres y apellidos</li>
              <li data-id="element-475">Número de Cédula</li>
              <li data-id="element-476">Correo electrónico</li>
              <li data-id="element-477">Número de teléfono</li>
              <li data-id="element-478">
                Dirección IP y datos de navegación (cookies, ubicación, tipo de
                navegador)
              </li>
              <li data-id="element-479">
                Información proporcionada mediante formularios de contacto o
                suscripción
              </li>
              <li data-id="element-480">
                Información proporcionada mediante formularios o requerimientos,
                con el objetivo de validación de identidad, pertenencia,
                validación de acceso a otras plataformas o tecnologías, u otros
                objetivos relacionados.
              </li>
            </ul>
          </section>

          <section data-id="element-481">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-482">
              4. FINALIDAD DEL TRATAMIENTO
            </h2>
            <p className="mb-4" data-id="element-483">
              Recopilamos tus datos con las siguientes finalidades:
            </p>
            <ul className="list-disc list-inside space-y-2" data-id="element-484">
              <li data-id="element-485">
                Validación de identidad, pertenencia, acceso a plataformas,
                validación de canales de comunicación u otros relacionados.
              </li>
              <li data-id="element-486">
                Gestionar la validación de identidad y acceso con terceras
                plataformas interconectadas.
              </li>
              <li data-id="element-487">
                Enviar información institucional, boletines, eventos, productos
                y servicios
              </li>
              <li data-id="element-488">
                Atender consultas o solicitudes realizadas a través de
                formularios de contacto
              </li>
              <li data-id="element-489">Gestionar inscripciones a eventos o programas</li>
              <li data-id="element-490">
                Gestionar promociones, beneficios, sistemas de fidelización y
                otras actividades de marketing
              </li>
              <li data-id="element-491">
                Realizar análisis estadísticos de navegación (uso de cookies)
              </li>
              <li data-id="element-492">Cumplir con obligaciones legales y regulatorias</li>
            </ul>
          </section>

          <section data-id="element-493">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-494">
              5. LEGITIMACIÓN PARA EL TRATAMIENTO
            </h2>
            <p className="mb-4" data-id="element-495">
              El tratamiento de tus datos se realiza con base en:
            </p>
            <ul className="list-disc list-inside space-y-2" data-id="element-496">
              <li data-id="element-497">Tu consentimiento expreso</li>
              <li data-id="element-498">
                El interés legítimo de TruID para cumplir su misión
                institucional
              </li>
              <li data-id="element-499">
                El cumplimiento de obligaciones legales, según la normativa
                ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                Personales – LOPDP)
              </li>
            </ul>
          </section>

          <section data-id="element-500">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-501">
              6. DESTINATARIOS DE LOS DATOS
            </h2>
            <p className="mb-4" data-id="element-502">
              Tus datos personales no serán compartidos con terceros, salvo que:
            </p>
            <ul className="list-disc list-inside space-y-2" data-id="element-503">
              <li data-id="element-504">Tengamos tu consentimiento previo</li>
              <li data-id="element-505">Sea requerido por autoridad competente conforme a la ley</li>
              <li data-id="element-506">
                Se usen herramientas tecnológicas de terceros (por ejemplo, para
                envío de newsletters, CRM o formularios o validación de accesos)
                con contratos que garantizan la protección de tus datos
              </li>
            </ul>
          </section>

          <section data-id="element-507">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-508">
              7. DERECHOS DEL TITULAR DE LOS DATOS
            </h2>
            <p className="mb-4" data-id="element-509">Tienes derecho a:</p>
            <ul className="list-disc list-inside space-y-2" data-id="element-510">
              <li data-id="element-511">Acceder a tus datos personales</li>
              <li data-id="element-512">Rectificar datos inexactos o incompletos</li>
              <li data-id="element-513">Eliminar tus datos (cuando proceda)</li>
              <li data-id="element-514">Oponerte al tratamiento</li>
              <li data-id="element-515">Solicitar la portabilidad de tus datos</li>
              <li data-id="element-516">Revocar el consentimiento en cualquier momento</li>
            </ul>
            <p className="mt-4" data-id="element-517">
              Puedes ejercer estos derechos escribiéndonos a{' '}
              <a href="mailto:protecciondatos@truid.org" className="text-teal-500 hover:text-teal-400 transition-colors font-medium" data-id="element-518">
                protecciondatos@truid.org
              </a>
            </p>
          </section>

          <section data-id="element-519">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-520">
              8. USO DE COOKIES
            </h2>
            <p data-id="element-521">
              Nuestros sitios utilizan cookies propias y de terceros para
              mejorar la experiencia de navegación y análisis del tráfico.
              Puedes aceptar, configurar o rechazar el uso de cookies desde el
              banner de consentimiento al ingresar al sitio.
            </p>
          </section>

          <section data-id="element-522">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-523">
              9. SEGURIDAD DE LA INFORMACIÓN
            </h2>
            <p data-id="element-524">
              TruID aplica medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales contra accesos no
              autorizados, pérdida, destrucción o alteración.
            </p>
          </section>

          <section data-id="element-525">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-526">
              10. CONSERVACIÓN DE LOS DATOS
            </h2>
            <p data-id="element-527">
              Tus datos serán conservados solo durante el tiempo necesario para
              cumplir con la finalidad para la que fueron recopilados o mientras
              exista una relación institucional o contractual. Posteriormente
              serán eliminados o anonimizados, según corresponda.
            </p>
          </section>

          <section data-id="element-528">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-529">
              11. CAMBIOS A ESTA POLÍTICA
            </h2>
            <p data-id="element-530">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              en cualquier momento. Cualquier cambio será publicado con la fecha
              de actualización correspondiente.
            </p>
          </section>

          <section data-id="element-531">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-532">
              12. AUTORIDAD DE CONTROL
            </h2>
            <p data-id="element-533">
              Si consideras que tus derechos no han sido respetados, puedes
              presentar un reclamo ante la Autoridad de Protección de Datos
              Personales de Ecuador, la Superintendencia de Protección de Datos
              Personales.
            </p>
          </section>

          <section data-id="element-534">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-535">
              13. VIGENCIA
            </h2>
            <p data-id="element-536">
              La vigencia de estas Políticas de Privacidad y Protección de Datos
              es desde el 21 de noviembre de 2025 y permanecerá vigente hasta
              que exista una nueva versión que la reemplace.
            </p>
          </section>
        </div>
      </div>
    </div>;
}